export function dateNow() {
    return new Date();
}
export function getTime() {
    return dateNow().getTime();
}
export function timeNow() {
    return dateNow().toLocaleTimeString(undefined, {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        fractionalSecondDigits: 3,
    });
}
export function now() {
    return Date.now();
}
